import * as angular from 'angular';

interface JQuery {
  highcharts: any;
}
// **************************************************************************************************
// You must include the Highcharts libraries  for this directive to work!
// **************************************************************************************************

// Given an object like this in the $scope:
//
//   $scope.example = function (input1, input2) {
//     if (we have enough data to create a chart) {
//       // Use our inputs to create a Highcharts configuration object and return that.
//       return highchartsConfigurationObject;
//     } else {
//       // If we don't have enough data to create a chart we should return null.
//       return null;
//     }
//   }
//
// And a directive like this in the HTML:
//   <div aptitude-micro-chart="example(foo, bar)"></div>
//
// You will get a graph based on the output of the example function.
//
// If you want a zoom magnifying glass to show when the user rolls his/her mouse over the graph then assign a zoom
// function to the micro-chart as well, like so:
//   <div aptitude-micro-chart="example(foo, bar)" zoom="doSomethingOnZoom()"></div>
//
// A magnifying glass will be overlaid on the graph whenever the user mouses over it and clicking on the graph will
// trigger $scope.doSomethingOnZoom().
export default function AptitudeMicroChartDirective() {
  'use strict';

  return {
    restrict: 'A',
    scope: {
      isStockChart: '=isStockChart',
      data: '=aptitudeMicroChart',
      zoom: '&?',

      icon: '<',
      hover: '<'
    },
    template: `<div>
                 <icon-with-hover icon="icon" hover="hover" ng-if="icon"></icon-with-hover>
                 <div class="graphContainer" ng-click="zoom()">
                   <div style="max-width: 100%;"></div>
                   <div ng-if="zoomOverlay" class="microChartZoom ss-icon ss-zoomin"></div>
                 </div>
               </div>`,
    replace: true,
    controller: function _aptitudeMicroChartController(
      $scope,
      $element,
      $attrs
    ) {
      'ngInject';

      function displayGraph(target, data, callback) {
        // I hate that I have to do this, but the Highcharts chart is grabbing mouse clicks and not bubbling them up,
        // even in those cases where it does not have an event handler to process them. So I have to hook up an event
        // handler myself to invoke the same function that the zoom overlay invokes.
        if (data != null && data.chart != null) {
          if (data.chart.events) {
            data.chart.events.click = callback;
          } else {
            data.chart.events = {
              click: callback
            };
          }

          if ($scope.isStockChart === true) {
            target.highcharts('StockChart', data);
          } else {
            target.highcharts(data);
          }
        }
      }

      // We want to put our graph into the first div within the .graphContainer div. It is being used to control the
      // appearance/disappearance of the magnifying glass overlay (if present).
      var $target = angular.element($element.find('div').children()[0]);

      // CAP-243
      // The "Close" button is hidden when in a modal because the default size is 400px.
      // If the height of the element is 0, then use 335 as the default
      if ($element.height() !== 0) {
        $target.height($element.height());
      } else {
        $target.height(335);
      }

      // This was ridiculously hard for some reason. If you use & to bind to a function in the parent scope from
      // within an isolated scope then AngularJS will always create a function and assign it in the $scope, even if
      // you made the attribute optional (that is, "&?"). So you can't test the $scope.zoom and expect to ever see it
      // undefined. There may be a function which _returns_ undefined, but there will always be a function bound
      // to the scope variable. Thus, to know if the user didn't define a value for the attribute, we have to use the
      // array of attributes to test.
      $scope.zoomOverlay = angular.isDefined($attrs.zoom);

      displayGraph($target, $scope.data, $scope.zoomWrapper);

      // This watches for any changes in the bound data and immediately updates the chart in response to the change.
      $scope.$watch('data', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue == null) {
            ($target as any).highcharts().destroy();
          } else {
            displayGraph($target, $scope.data, $scope.zoomWrapper);
          }
        }
      });
    }
  };
}
